import gql from 'graphql-tag';
import { VendorLayerFragment } from '../fragments';

export default gql`
  query paginationQuery(
    $perPage: Int
    $page: Int
    $filter: VendorLayerCollectionFilters
    $orderBy: VendorLayerOrderInput
  ) {
    vendorLayerPagination(
      perPage: $perPage
      page: $page
      filter: $filter
      orderBy: $orderBy
    ) {
      count
      elasticQuery
      items {
        ...VendorLayerFragment
      }
      pageInfo {
        pageCount
        currentPage
      }
    }
  }
  ${VendorLayerFragment}
`;
